export function useNavigateByKey({ cell, cells }) {
  const { ref: cellRef, tabIndex, dataKey } = cell

  function focusCellByTabIndex(tabIndex) {
    const matchingCell = cells.flat().find((cell) => cell.tabIndex === tabIndex)

    if (matchingCell) {
      matchingCell.ref.current.focus()
    }
  }

  function focusCellInColumnWithRowOffset(direction) {
    const up = direction === "up"

    const matchingTabIndices = cells
      .flat()
      .filter((cell) => cell.dataKey === dataKey && !!cell.tabIndex)
      .filter((cell) =>
        up ? cell.tabIndex < tabIndex : cell.tabIndex > tabIndex
      )
      .map((cell) => cell.tabIndex)

    if (matchingTabIndices.length === 0) return

    focusCellByTabIndex(
      up ? Math.max(...matchingTabIndices) : Math.min(...matchingTabIndices)
    )
  }

  const NAVIGATION_KEYS = [
    "ArrowLeft",
    "ArrowUp",
    "ArrowRight",
    "ArrowDown",
    "Tab",
  ]

  const navigateByKey = (e) => {
    const { key, shiftKey, target: element } = e

    if (!NAVIGATION_KEYS.includes(key)) return false

    // Ignore keypresses inside the cell except tabs as we respond to tabbing out of a child input.
    const keyEventInCellChild = element !== cellRef.current
    if (keyEventInCellChild && key !== "Tab") return false

    e.preventDefault()
    e.stopPropagation()

    switch (key) {
      case "ArrowLeft":
        focusCellByTabIndex(element.tabIndex - 1)
        break
      case "ArrowUp":
        focusCellInColumnWithRowOffset("up")
        break
      case "ArrowRight":
        focusCellByTabIndex(element.tabIndex + 1)
        break
      case "ArrowDown":
        focusCellInColumnWithRowOffset("down")
        break
      case "Tab":
        focusCellByTabIndex(cellRef.current.tabIndex + (shiftKey ? -1 : 1))
        break
      default:
        break
    }

    return true
  }

  return navigateByKey
}
